import { render, staticRenderFns } from "./ShareEmailComponent.vue?vue&type=template&id=98273868&scoped=true"
import script from "./ShareEmailComponent.vue?vue&type=script&lang=js"
export * from "./ShareEmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98273868",
  null
  
)

export default component.exports